<mat-tab-group color="primary" animationDuration="0ms" (selectedIndexChange)="tabIndexChange.emit($event)">
    <mat-tab label="{{'STOCK.MANAGEMENT.SIMPLE' | translate}}" />
    <mat-tab label="{{'STOCK.MANAGEMENT.COMPLEX' | translate}}" />
    <mat-tab label="{{'STOCK.MANAGEMENT.COMBINATIONS' | translate}}" />
    <mat-tab label="{{'STOCK.MANAGEMENT.RAW_MATERIALS' | translate}}" />
</mat-tab-group>
